import { storageUiSettingsRemove } from "./storageUiSettingsRemove";
import { storageUiSettingsUpdate } from "./storageUiSettingsUpdate";
const toDomain = (uiSettingDto) => ({
    aggregateId: uiSettingDto.id,
    key: uiSettingDto.key,
    value: uiSettingDto.value,
    domainEvents: [],
});
const fromDomain = (uiSetting) => ({
    id: uiSetting.aggregateId,
    key: uiSetting.key,
    value: uiSetting.value,
});
const getUiSetting = ({ storage }) => async (aggregateId) => {
    const uiSettingDto = await storage.read(aggregateId);
    if (!uiSettingDto) {
        throw new Error(`UiSetting not found: ${aggregateId}`);
    }
    return toDomain(uiSettingDto);
};
const saveUiSetting = ({ storage }) => async (aggregateRoot) => {
    await Promise.all([
        await storageUiSettingsUpdate({ storage })(aggregateRoot),
        await storageUiSettingsRemove({ storage })(aggregateRoot),
    ]);
};
export { fromDomain, getUiSetting, saveUiSetting };
